// Vue 3 自定义指令
// 注意：Vue 3 中需要在 main.js 中注册全局指令

/**
 * 防抖指令
 * 例：<a-button v-debounce="[reset,`click`,300]">刷新</a-button>
 * 简写：<a-button v-debounce="[reset]">刷新</a-button>
 */
export const debounce = {
    mounted(el, binding) {
        let [fn, event = "click", time = 300] = binding.value;
        let timer;
        el.addEventListener(event, () => {
            timer && clearTimeout(timer);
            timer = setTimeout(() => fn(), time);
        });
    }
};

/**
 * 节流指令
 * 例：<a-button v-throttle="[reset,`click`,300]">刷新</a-button>
 * 传递参数：<a-button v-throttle="[()=>reset(param),`click`,300]">刷新</a-button>
 */
export const throttle = {
    mounted(el, binding) {
        let [fn, event = "click", time = 300] = binding.value;
        let now, preTime;
        el.addEventListener(event, () => {
            now = new Date();
            if (!preTime || now - preTime > time) {
                preTime = now;
                fn();
            }
        });
    }
};

// 注册指令的辅助函数
export function registerDirectives(app) {
    app.directive('debounce', debounce);
    app.directive('throttle', throttle);
}
